import { Navigate, useParams } from 'react-router-dom';
import React from 'react';
import { paths } from '@/app/paths';

/** The old /admin/users/import/:importId address (in earlier notifications): its report. */
export const UserImportRedirect = () => {
	const { importId } = useParams();
	return <Navigate to={`${paths.admin}/imports/${importId}`} replace />;
};
